import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Ladestasjoner from "../../RouteDescription/Ladestasjoner";

export default function LadestasjonListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  return(
    <>
      {props.roadFeatureResponse && 
      props.roadFeatureResponse.ladestasjoner && 
      props.roadFeatureResponse.ladestasjoner.length !== 0 &&
      <>
      <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Ladestasjoner (${props.roadFeatureResponse?.ladestasjoner.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <Ladestasjoner roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
        </>
      }
    </>
  )
}